import React, { useEffect, useState } from 'react'
import { QuickFilterScope } from '../../../enums/quick-filters';
import { IQuickFilter } from '../../../interfaces/common/quick-filters';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import FilterChips from '../filter-chips/filter-chips';
import { useQuickFiltersContext } from '../../../contexts/quick-filters-context';
import ConfirmAction from '../confirm-action/confirm-action';
import { quickFiltersToFilterOptions } from '../../../utils/quick-filters';
import { FilterOptionsChips } from '../filter-bar/filter-chips';
import { useSnackBar } from '../../../contexts/snackbar';
import { IconWithText } from '../styles/components';
import { ElectricBolt } from '@mui/icons-material';
import { useTabPersistedState } from '../tabPersistedState/tab-persisted-state';

interface QuickFiltersProps {
    scope: QuickFilterScope;
    onSelect: (quickFilters: IQuickFilter | null) => void;
    sourceView: string;
}

function QuickFilters({ scope, onSelect, sourceView }: QuickFiltersProps) {
    const { isLoading, quickFilters, deleteQuickFilter } = useQuickFiltersContext();
    const { showMessage } = useSnackBar();

    const [selectedQuickFiltersName, setSelectedQuickFiltersName] = useTabPersistedState(`selectedQuickFiltersName-${sourceView}`, '');
    const [relevantQuickFilters, setRelevantQuickFilters] = useState<IQuickFilter[]>([]);
    const [openConfirmDeleteFor, setOpenConfirmDeleteFor] = useState<IQuickFilter | undefined>(undefined);

    const handleDeleteQuickFilter = async () => {
        if (!openConfirmDeleteFor?.id) return;
        
        try {
            await deleteQuickFilter(openConfirmDeleteFor.id);
            showMessage("Quick filter deleted successfully", "success");
            setOpenConfirmDeleteFor(undefined);
        } catch {
            showMessage("Failed to delete quick filter", "error");
        }
    }

    useEffect(() => {
        setRelevantQuickFilters(quickFilters.filter((quickFilter) => quickFilter.scope === scope));
    }, [quickFilters]);

    useEffect(() => {
        console.log('selectedQuickFiltersName = ', selectedQuickFiltersName);
        const filtersToApply = relevantQuickFilters.filter((quickFilter) => selectedQuickFiltersName === quickFilter.name);
        if (filtersToApply.length > 0) {
            onSelect(filtersToApply[0]);
        } else {
            onSelect(null)
        }
    }, [selectedQuickFiltersName, relevantQuickFilters]);

    return <Box display={"flex"} flexDirection={"column"} gap={2}> {
        isLoading ? 
    <CircularProgress size={20} /> 
    :
    relevantQuickFilters.length > 0 
    ?
    <FilterChips 
            label=<IconWithText centered><ElectricBolt color="primary" fontSize="large" /> Quick Filters</IconWithText>
            centered
            options={relevantQuickFilters.map((quickFilter) => quickFilter.name)} 
            selected={selectedQuickFiltersName ? [selectedQuickFiltersName] : []} 
            onChange={(selected) => {
                selected.length > 0 ? setSelectedQuickFiltersName(selected[0]) : setSelectedQuickFiltersName('')
            }} 
            onDelete={(option) => {
                setOpenConfirmDeleteFor(relevantQuickFilters.find((quickFilter) => quickFilter.name === option));
            }}
        /> 
        : 
        null 
    }

    {
        selectedQuickFiltersName && 
        <Box display={"block"}>
            <Typography>{relevantQuickFilters.find((quickFilter) => quickFilter.name === selectedQuickFiltersName)?.description}</Typography>
        </Box>
    }
    
    
      {openConfirmDeleteFor && <ConfirmAction
            isOpen={openConfirmDeleteFor != undefined}
            action={handleDeleteQuickFilter} 
            message={'Are you sure you want to delete this quick filter?'} 
            handleClose={() => setOpenConfirmDeleteFor(undefined)}
            >
            <Alert severity="warning">You can recreate this quick filter at any time.</Alert>

            <Box
                sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, marginBottom: 2, marginTop: 2 }}
            >
                {
                    
                }
                <FilterOptionsChips filterOptions={ quickFiltersToFilterOptions(openConfirmDeleteFor)} />
            </Box>
     </ConfirmAction>}
    </Box>
}

export default QuickFilters